import { Box } from '@wix/design-system';
import {
  Faq,
  NonBlockerWrapper,
  PageFooter,
} from '@wix/package-picker-shared-eclipse';
import React from 'react';
import { AfnicSection } from '../../components/AfnicSection';
import { FeaturesGrid } from '../../components/FeaturesGrid';
import { EnterpriseBanner } from '../../components/EnterpriseBanner';
import { HeaderBanner } from '../../components/HeaderBanner';
import { PlansSection } from '../../components/PlansSection';

export const SelectPlanPage = () => {
  const gridRef = React.useRef<HTMLDivElement>(null);

  return (
    <Box
      direction="vertical"
      width="100%"
      align="center"
      paddingBottom="SP6"
      boxSizing="border-box"
    >
      <HeaderBanner />
      <Box
        margin="0 auto"
        direction="vertical"
        width="100%"
        align="center"
        padding="0px 30px"
        boxSizing="border-box"
      >
        <PlansSection gridRef={gridRef} />
        <Box width="100%" align="center" padding="0 SP5">
          <AfnicSection />
        </Box>
        <Box
          width="100%"
          align="center"
          marginTop="120px"
          padding="0 SP5"
          boxSizing="border-box"
        >
          <EnterpriseBanner />
        </Box>
        <Box width="100%" align="center" marginTop="120px" maxWidth="1320px">
          <FeaturesGrid innerRef={gridRef} />
        </Box>
        <Box marginTop="SP7" width="100%">
          <NonBlockerWrapper componentName="Faq">
            <Faq />
          </NonBlockerWrapper>
        </Box>
        <PageFooter />
      </Box>
    </Box>
  );
};
